import {List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Table from 'web-app/react/components/table/model';

export const fetchDeposits = institutionId =>
    RESTClient.getAuthenticatedObservable(`v2/deposit-report/${institutionId}`).map(response => ({
        past: response.tables.past ? Table.fromAPI(response.tables.past) : null,
        current: response.tables.current ? Table.fromAPI(response.tables.current) : null,
        future: response.tables.future ? Table.fromAPI(response.tables.future) : null,
        csv: response.csv,
    }));

export const fetchDirectDebitFiles = ({institutionId, organizationId}) =>
    RESTClient.getAuthenticatedObservable('v2/direct-debit', {
        institutionId,
        organizationId,
    }).map(response => ({
        ...response,
        files: List(response.files),
        behaviors: new BehaviorsCollection(response.behaviors),
    }));

export const makeDirectDebitRun = ({institutionId, organizationId, paymentDate, filetype}) =>
    RESTClient.postAuthenticatedObservable('v2/direct-debit/generate', {
        institutionId,
        organizationId,
        paymentDate,
        filetype,
    });

export const makeDirectCreditRun = ({institutionId, organizationId, paymentDate}) =>
    RESTClient.postAuthenticatedObservable('v2/direct-credit/generate', {
        institutionId,
        organizationId,
        paymentDate,
        filetype: 'xml',
    });
